var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-language",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5h7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3v2c0 4.418 -2.239 8 -5 8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9c0 2.144 2.952 3.908 6.7 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20l4 -9l4 9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 18h-6.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguagesIcon);
export default __webpack_public_path__ + "static/media/languages-icon.6c0193646dccbf66187ccd4ccc8df5a6.svg";
export { ForwardRef as ReactComponent };